import { useState } from "react";
import CloseIcon from "../../assets/icons/close.svg";

import "./ModalAddCategory.css";
import { categoryService } from "../../services/category.service";
import { closeModal, showModal } from "../../utils/functions/modal";

const ModalAddCategory = ({ setMessage, onSuccess }) => {
  const [nameCategory, setNameCategory] = useState("");

  const clearInputs = () => {
    setNameCategory("");
  };

  const handleSubmitCategory = async (e) => {
    e.preventDefault();

    closeModal(".container-modal-add-category");
    showModal(".container-modal-confirm");
    setMessage({
      description: "Agregando categoría...",
      status: 1000,
    });

    const response = await categoryService.addCategory(nameCategory.trim());

    setTimeout(() => {
      if (response.data.status === 200) {
        clearInputs();
        onSuccess?.();
      }
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
    }, 1500);
  };

  return (
    <>
      <div className="container-modal-add-category">
        <div className="modal-add-category">
          <div className="header-modal">
            <h3>Agregar Categoría</h3>
            <button onClick={() => closeModal(".container-modal-add-category")}>
              <img src={CloseIcon} alt="" />
            </button>
          </div>
          <form onSubmit={handleSubmitCategory} className="body-modal">
            <div className="input">
              <label htmlFor="nameCategory">Nombre</label>
              <input
                type="text"
                id="nameCategory"
                name="nameCategory"
                required
                onChange={(e) => setNameCategory(e.target.value)}
                value={nameCategory}
                placeholder="Accesorios"
              />
            </div>

            <button className="btn-add-product">AGREGAR CATEGORÍA</button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ModalAddCategory;
